import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _isNativeReflectConstruct from "@babel/runtime/helpers/isNativeReflectConstruct";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
import { Component } from 'react';
export var SimpleErrorBoundary = /*#__PURE__*/function (_Component) {
  function SimpleErrorBoundary() {
    var _this;
    _classCallCheck(this, SimpleErrorBoundary);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, SimpleErrorBoundary, [].concat(args));
    _this.state = {
      hasError: false
    };
    return _this;
  }
  _inherits(SimpleErrorBoundary, _Component);
  return _createClass(SimpleErrorBoundary, [{
    key: "componentDidCatch",
    value: function componentDidCatch(error, info) {
      this.setState({
        hasError: true
      });
      console.error('An error has occurred while rendering the component!', error, info);
    }
  }, {
    key: "render",
    value: function render() {
      if (this.state.hasError) {
        return 'Error';
      }
      return this.props.children;
    }
  }]);
}(Component);
export default SimpleErrorBoundary;